import React from 'react';
import cx from 'classnames';

type Variant = 'primary' | 'secondary';
type Size = 'default' | 'small';

const BUTTON_CLASSES: Record<Variant, Record<Size, string>> = {
  primary: {
    default:
      "rounded-md border-0 bg-[#00afd8] px-5 py-3 font-['GT-Walsheim-Pro-Bold'] text-[1.4rem] uppercase tracking-[0.02em] text-white transition-[background_250ms_ease-in-out,transform_150ms_ease] hover:bg-[#009fc4] focus:outline-none focus:ring-2 focus:ring-[#009fc4] disabled:cursor-not-allowed disabled:opacity-40 active:bg-[#0290b2]",
    small:
      "rounded-md border-0 bg-[#00afd8] px-4 py-2 font-['GT-Walsheim-Pro-Bold'] text-[1.3rem] uppercase tracking-[0.02em] text-white transition-[background_250ms_ease-in-out,transform_150ms_ease] hover:bg-[#009fc4] focus:outline-none focus:ring-2 focus:ring-[#009fc4] disabled:cursor-not-allowed disabled:opacity-40 active:bg-[#0290b2]",
  },
  secondary: {
    default:
      "rounded-md border-2 border-[#00afd8] bg-white px-5 py-3 font-['GT-Walsheim-Pro-Bold'] text-[1.4rem] uppercase tracking-[0.02em] text-[#00afd8] transition-[background_250ms_ease-in-out] hover:bg-[#e6f9fd] focus:outline-none focus:ring-2 focus:ring-[#009fc4] disabled:cursor-not-allowed disabled:opacity-40",
    small:
      "rounded-md border-2 border-[#00afd8] bg-white px-4 py-2 font-['GT-Walsheim-Pro-Bold'] text-[1.3rem] uppercase tracking-[0.02em] text-[#00afd8] transition-[background_250ms_ease-in-out] hover:bg-[#e6f9fd] focus:outline-none focus:ring-2 focus:ring-[#009fc4] disabled:cursor-not-allowed disabled:opacity-40",
  },
};

interface Props {
  children: React.ReactNode;
  variant?: Variant;
  size?: Size;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
}

const TailwindButton: React.FC<Props> = ({
  children,
  variant = 'primary',
  size = 'default',
  type = 'button',
  disabled,
  onClick,
  className,
}) => {
  return (
    <button type={type} disabled={disabled} onClick={onClick} className={cx(BUTTON_CLASSES[variant][size], className)}>
      {children}
    </button>
  );
};

export default TailwindButton;
